import { FontSize24, Spacing8 } from 'autogen/design-tokens/tokens';
import type { SearchModel } from 'autogen/swagger/all';
import { SearchSuggestion } from 'components';
import Layout from 'components/Layout';
import Flex from 'components/Layout/components/Flex';

import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';
import format from 'helpers/translations';
import useIsAppRequest from 'hooks/user/useIsAppRequest';
import RelatedTags from 'modules/relatedTags';
import styled from 'styled-components';

const SearchHeading = styled.h1`
    font-size: ${FontSize24};
    margin: 0;
`;

export default function SearchPageHeader({
    model: { searchHeading, suggestion, relatedTags }
}: {
    model: SearchModel;
}) {
    const isClubMatasAppRequest = useIsAppRequest();
    const hasSuggestionOrRelatedTags = suggestion || !!relatedTags.length;

    if (isClubMatasAppRequest && !hasSuggestionOrRelatedTags) {
        return null;
    }

    return (
        <Layout.Section>
            <Flex.Column gap={Spacing8}>
                {!isClubMatasAppRequest && <SearchHeading>{format(searchHeading)}</SearchHeading>}

                {hasSuggestionOrRelatedTags && (
                    <div>
                        {suggestion && <SearchSuggestion {...suggestion} />}
                        {!!relatedTags.length && <RelatedTags tags={relatedTags} scrollable={false} />}
                    </div>
                )}
            </Flex.Column>
        </Layout.Section>
    );
}
